import { useState, useEffect, useContext } from "react";
import UserContext from "../../../context/order/UserContext";
import AdminOrdersContext, {
  AdminOrdersProvider
} from "../../../context/order/AdminOrdersContext.tsx";
import AuthenticationContext from "../../../context/Authentication/AuthenticationContext.tsx";
import { useParams } from "react-router-dom";
import ReactDOM from "react-dom";
import PanelFormatterHOC from "./PanelFormatterHOC.tsx";
import AdminOrder from "./AdminOrders";
import OrderModal from "./OrderModal.tsx";

import useAxios from "../../../services/useAxios.tsx";

export default function Orders({ pageName }) {
  const { execute: getAllOrder } = useAxios("api/get_all_orders");
  const { orders, setOrders } = useContext(AdminOrdersContext);
  // console.log("orders***", orders);
  const { superAdminOrders, customerOrders } = useContext(UserContext);
  let auth = useContext(AuthenticationContext);

  const [statusUpdater, setStatusUpdater] = useState(false);
  // console.log(auth);
  let parameter = {};
  let param = useParams();
  let result;

  useEffect(() => {
    async function apiHandler() {
      //   if (customerOrders) {
      //     parameter = { uid: auth.userInfo.id };
      //   } else if (superAdminOrders) {
      // parameter = {};
      //   } else {
      //     parameter = { supplier_id: param.supplier_id };
      //   }
      // if (auth.userInfo.access_level.isSuperAdmin == true) {
      //   parameter = {};
      // } else {
      if (param.supplier_id != undefined) {
        parameter = { supplier_id: param.supplier_id };
      }
      // }

      //   result = await connection("api/get_all_orders", parameter);
      result = await getAllOrder(parameter);

      result?.data?.length > 0 && setOrders(result.data.reverse());
      // console.log("result", result);
      // ordersMain = result.data;
      // console.log(ordersMain);

      // console.log("orders", result, orders);
    }
    apiHandler();
  }, [customerOrders, superAdminOrders, statusUpdater]);

  return (
    <>
      <PanelFormatterHOC
        // title={["سفارشات درحال انتظار", "سفارشات تکمیل شده", "گزارش"]}
        title={["سفارشات"]}
        label="orders"
        components={[
          <AdminOrder
            pageName={pageName}
            statusUpdater={statusUpdater}
            setStatusUpdater={setStatusUpdater}
          />
        ]}
        // components={[
        //   <WaitingOrdersTab
        //     orders={orders?.filter((value) => value.lats_order_status != 4)}
        //   />,
        //   <CompletedOrdersTab
        //     orders={orders?.filter((value) => value.lats_order_status == 4)}
        //   />,
        //   <Report />,
        // ]}
      />
      {/* {ReactDOM.createPortal( */}
      <OrderModal />
      {/* //   , document.getElementById("modals"))} */}
    </>
  );
}
